import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { AppButtonModule } from '../../../../dave-utils-module/app-button-module/app-button.module';

export type PDFEditableDialogData = undefined
export type PDFEditableDialogReturnData = undefined | boolean

@Component({
    selector: 'app-pdf-editable-dialog',
    standalone: true,
    imports: [CommonModule, AppButtonModule, MatLegacyDialogModule],
    templateUrl: './pdf-editable-dialog.component.html',
    styleUrls: ['./pdf-editable-dialog.component.scss'],
})
export class PdfEditableDialogComponent {
    constructor() {
    }
}
